import React, {useContext, useRef} from 'react';
import { CommonProps } from '../types/UploadItem';
import { useAppStore } from "../../../../../../GlobalStore/GlobalStore";
import {GlobalContext} from "../../../../../../App.tsx";
import {handleFileSelected} from "../../../../../../Utils/uploadUtils/UploadUtils.ts";
import { DocumentIcon, ImageIcon, CameraIcon, FileIcon } from './UploadIcons';

export const FileUploadItem: React.FC<CommonProps> = ({
    buttonClasses,
    theme,
    accept = "*",
    capture,
    label = "Upload"
}) => {
    const { userObjRef, settingsObjRef, websocketRef, setupWebsocketHelper } = useContext(GlobalContext);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const updateSelectedMedia = useAppStore((state: any) => state.updateSelectedMedia);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setDynamicStateObj({isUploadOpen: false});

        const files = Array.from(event.target.files || []);
        if (files.length === 0) return;

        files.map(async (file: any) => {
            await handleFileSelected(file, userObjRef, settingsObjRef, updateSelectedMedia, websocketRef, setupWebsocketHelper, setDynamicStateObj);
        });
        event.target.value = "";
    };

    const handleFileUpload = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        fileInputRef.current?.click();
    };
    
    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept={accept}
                capture={capture}
                multiple
                className="hidden"
            />
            <div className="flex items-center gap-3 w-full cursor-pointer" onClick={handleFileUpload}>
                <button
                    type="button"
                    className={buttonClasses}
                    title={label}
                >
                    {label === "Photos" && <ImageIcon className={`w-[21px] h-[21px]`} theme={theme} />}
                    {label === "Camera" && <CameraIcon className={`w-[21px] h-[21px]`} theme={theme} />}
                    {label === "Documents" && <DocumentIcon className={`w-[21px] h-[21px]`} theme={theme} />}
                    {label !== "Photos" && label !== "Camera" && label !== "Documents" && (
                        <FileIcon className={`w-[21px] h-[21px]`} theme={theme} />
                    )}
                </button>
                <span className={`text-sm ${theme === 'dark' ? 'text-neutral-200' : 'text-neutral-700'} flex-grow`}>
                    {label}
                </span>
            </div>
        </>
    );
};